<template>
  <div class="profile">
    <v-row no-gutters justify="center">
      <v-card>
        <v-row no-gutters>
          <v-col md="8" sm="12">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline2" style="margin: 10px 0 0">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('dashboard.menu.promoter_dashboard.promoter_name')"
                      v-model="promoterNameModel"
                      :error-messages="isError ? $t('dashboard.menu.promoter_dashboard.' + message) : ''"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('promoterName')"
                      :placeholder="userDetails.promoterName"
                    ></v-text-field>
                </v-list-item-title>
                <v-list-item-title class="headline2">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('dashboard.menu.promoter_dashboard.email')"
                      v-model="emailAddress"
                      :error-messages="isError ? $t('dashboard.menu.promoter_dashboard.' + message) : ''"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('emailAddress')"
                      :placeholder="userDetails.emailAddress"
                      :hint="$t('dashboard.menu.promoter_dashboard.change_email_info')"
                      persistent-hint
                    ></v-text-field>
                </v-list-item-title>
                <v-list-item-title class="headline2">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('dashboard.menu.promoter_dashboard.last_logged_ip')"
                      v-model="LastLoginIp"
                      style="margin: 10px 0"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col md="4" sm="12" class="avatarProfile">
            <v-img
              width="100%"
              :src="imageUrl"
              v-on:error="ImgError"
              style="max-height: 280px;"
            ></v-img>
            <v-row no-gutters>
              <v-dialog v-model="dialog" persistent max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mc-center-t min-btn-w" outlined v-bind="attrs" v-on="on">
                    {{
                      $t(
                        "dashboard.menu.promoter_dashboard.change_your_password"
                      )
                    }}
                  </v-btn>
                </template>
                <v-card class="borderDialog">
                  <v-card-title >
                    <span class="headline">
                      {{ $t("dashboard.menu.promoter_dashboard.reset_your_password") }}
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="password"
                            :label="$t('dashboard.menu.promoter_dashboard.new_password')"
                            type="password"
                            id="password"
                            name="password"
                            :error-messages="
                              submitted && !$v.password.required
                                ? 'Password is required'
                                : submitted &&
                                  (!$v.password.minLength )
                                ? 'Password must be at least 8 characters'
                                : ''
                            "
                            required
                            outlined dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="verifyPassword"
                            :label="$t('dashboard.menu.promoter_dashboard.verify_password')"
                            type="password"
                            id="verifyPassword"
                            name="verifyPassword"
                            :error-messages="
                              submitted && !$v.verifyPassword.required
                                ? 'Confirm Password is required'
                                : submitted && !$v.verifyPassword.sameAsPassword
                                ? 'Cannot verify password'
                                : ''
                            "
                            required
                            outlined dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darken-1" dark small @click="dialog = false, password= '', verifyPassword=''">
                      {{ $t("dashboard.menu.promoter_dashboard.close") }}
                    </v-btn>
                    <v-btn color="darken-1" dark small @click="handleSubmit">
                      {{ $t("dashboard.menu.promoter_dashboard.save") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn class="mc-center-b min-btn-w" outlined @click="upload()">
                {{ $t("dashboard.menu.promoter_dashboard.change_your_image") }}
              </v-btn>
              <input
                style="display: none"
                type="file"
                id="uploadImage_"
                name="uploadImage_"
                accept="image/*"
                @change="onImageChange($event)"
              />
            </v-row>
          </v-col>
          <br />
        </v-row>
      </v-card>
    </v-row>
    <SGSNotificationConfirm v-if="alertError" :notificationMessage="msg" 
    @cancel="alertError=false;" type="error" :reject="$t('common.form.cancel')"/>
  </div>
</template>
<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { validationMixin } from "vuelidate";
import axios from "axios";
import AsyncComputed from "vue-async-computed";
import Vue from "vue";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

import {
  required,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls, validationMixin],
  components: {
    SGSNotificationConfirm
  },
  validations: {
    password: {
      required,
      minLength: minLength(8)
    },
    verifyPassword: { required, sameAsPassword: sameAs("password") },
  },
  data() {
    return {
      navigationBGColor: "#FFF",
      dialog: false,
      chosenFile: null,
      userDetails: [],
      LastLoginIp: null,
      menu_: [{ promoterName: false }, { emailAddress: false }],
      promoterName: null,
      emailAddress: null,
      isError: false,
      message: null,
      password: "",
      verifyPassword: "",
      submitted: false,
      uploadImage_: null,
      fileName: null,
      failed_image: true,
      imageUrl: null,
      msg: '',
      alertError: false
    };
  },
  computed: {
    promoterNameModel: {
      get() {
        return this.$escapeHtml.decode(this.promoterName);
      },
      set(newValue) {
        this.promoterName = newValue;
      }
    }
  },
  asyncComputed: {
    imageUrl: async function () {
      var user = await this.getUser();

      var imageUrl_ = user.existFile
        ? process.env.VUE_APP_ROOT + "/laravel/public" + user.image
        : this.failed_image
        ? process.env.VUE_APP_ROOT + user.image
        : require("@/assets/images/orgPlaceholder.jpg.png");

      return imageUrl_;
    },
  },
  methods: {
    async handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let data = {};
      data.password = this.password;

      await this.postApi(
        "/api/v1/users/current/changeUserPassword",
        data
      );

      this.password = ""
      this.verifyPassword = ""
      this.dialog = false;
    },
    upload() {
      document.getElementById("uploadImage_").click();
    },
    async onImageChange(e) {
      this.uploadImage_ = e.target.files[0];
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.fileName = files[0].name;
      this.uploadImage();
    },
    async createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    async uploadImage() {
      const data = new FormData();
      data.append("userId", this.userDetails.id);
      data.append("image", this.uploadImage_);
      data.append("fileName", this.fileName);

      let axiosConfig = {
        headers: { "content-type": "multipart/form-data" },
      };

      const response = await axios
        .put(
          `${this.root}/laravel/public/api/v1/promoter/profile/picture`,
          data,
          axiosConfig
        )
        .catch(
          function (error) {
            const status = error.response.status;

            switch (status) {
              case 401:
                window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                break;
            }
          }.bind(this)
        );
      if (response.data.success == 1) {
        this.imageUrl =
          process.env.VUE_APP_ROOT + response.data.message;
        this.$emit("image", this.imageUrl);
      }else{
          this.msg = this.$t('dashboard.menu.raceDetails.alertFile');
          this.alertError = true;
      }
    },
    async ImgError() {
      this.failed_image = false;
      this.imageUrl = require("@/assets/images/orgPlaceholder.jpg.png");
    },
    async getUser() {
      const response = await this.api("get", "/api/v1/users/current");
      this.userDetails = response.message;
      //this.promoterName = response.message.promoterName;
      //this.emailAddress = response.message.emailAddress;

      return response.message;
    },
    async getLastLoginIp() {
      const response = await this.api(
        "get",
        "/api/v1/users/current/getLastLoginIp"
      );
      this.LastLoginIp = response.message[0];
    },
    close(id) {
      this.emailAddress = this.userDetails.emailAddress;
      this.promoterName = this.userDetails.promoterName;
      this.menu_[id] = false;
      this.isError = false;
    },
    async sendMessage(input) {
      let data = {
        userId: this.userDetails.id,
        field: input,
        value: this[input]
      };

      const response = await this.putApi(
        "/api/v1/promoter/profile",
        data
      );

      if (response.success == 0) {
        this.isError = true;
        this.message = response.message;
      } else {
        this.userDetails.emailAddress = this.emailAddress;
        this.userDetails.promoterName = this.promoterName;
        this.menu_[input] = false;
        this.isError = false;
      }
    },
    async getProfile() {
      const user = await this.getUser();
      const response = await this.api("get", `/api/v1/promoter/profile/${user.id}`);
      this.userDetails = response.message;
      this.promoterName = response.message.promoterName;
      this.emailAddress = response.message.emailAddress;
    },
  },
  created: function () {
    this.navigationBGColor = process.env.VUE_APP_HEADER_COLOR;
    this.getLastLoginIp();
  },
  mounted () {
    this.getProfile();
  }
};
</script>

<style>
.profile { padding: 12px; }
.profile .v-card .row {padding: 0% 4%;}
.profile .v-card .row .col:first-child { text-align: left;}
.profile .v-card .row .avatarProfile { text-align: right; padding: 16px;}
.profile .headline2 {font-size: 14px !important;color: var(--v-lighten-base) !important;}
.theme--dark.v-list-item .v-list-item__subtitle,
.theme--dark.v-list-item .v-list-item__action-text {padding-left: 2%;padding-bottom: 1%;}
.mc-btn-l {margin: 1rem .5rem 1rem auto;}
.mc-btn-r {margin: 1rem auto 1rem .5rem;}
.mc-center-t {margin: 1rem auto 0;}
.mc-center-b {margin: 1rem auto;}
.min-btn-w {min-width: 292px !important;}
.v-image__image--cover {background-size: contain;}
.profile .headline {color: var(--v-primary-darken2) !important; font-size: 14px !important;}
@media (max-width: 1024px) {
  .profile .theme--dark.v-list-item .v-list-item__subtitle,
  .profile .theme--dark.v-list-item .v-list-item__action-text {
    font-size: 11.5px;
    padding-left: 2%;
    padding-bottom: 2%;
  }
}
.theme--light.v-messages, .v-text-field__details {
    display: contents !important;
}
</style>

<style scoped>
.v-application .headline {
  font-size: 24px !important;
}
.v-dialog > .v-card > .v-card__text {
    padding: 0 40px 20px;
}
.v-card__actions .v-btn {
    background-color: var(--v-primary-darken2) !important;
    color: white !important;
}
.borderDialog{
  border: 1px solid;
  border-color: black !important;
}
</style>
